var React = require('react');

function Send (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"An icon pointing right"),React.createElement("path",{"d":"M15 8v-.001zM1.023 14.992c-.014-.011-.028-.027-.02-.066L2.248 8.5h11.825zm-.02-13.921c-.008-.037.006-.053.02-.063.006-.005.012-.008.018-.008l.015.004L14.078 7.5H2.25zM15.416 7.05L1.502.109A1.034 1.034 0 0 0 .418.211 1.057 1.057 0 0 0 .02 1.264L1.327 8 .02 14.735A1.057 1.057 0 0 0 1.041 16c.157 0 .315-.037.461-.11l13.915-6.941C15.777 8.77 16 8.406 16 8c0-.407-.224-.771-.583-.95z","fill":"#fff","fillRule":"evenodd","key":1})]);
}

Send.defaultProps = {"height":"16","width":"16"};

module.exports = Send;

Send.default = Send;
